import $ from 'jquery';

export default class ReadMore {
    constructor() {
        if($('.js-read-more').length) {
            $('.js-read-more').on('click', function() {
                const $this = $(this);
                const $secondary_content = $this.next();

                if($secondary_content.hasClass('is-active')) {
                    $this.text($this.data('read-more'));
                } else {
                    $this.text($this.data('read-less'));
                };

                $secondary_content.slideToggle();
                $secondary_content.toggleClass('is-active');
            });
        };
    };
};
